/* unplugin-vue-components disabled */import { render } from "./utility-phone-contact.vue?vue&type=template&id=d0400be6"
import script from "./utility-phone-contact.vue?vue&type=script&lang=js"
export * from "./utility-phone-contact.vue?vue&type=script&lang=js"

import "./utility-phone-contact.vue?vue&type=style&index=0&id=d0400be6&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__